import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import get from 'lodash/get';

const useStyles = makeStyles(theme => {
  const { left, marginLR } = theme.mixins;

  return {
    wrapper: {
      background: props =>
        get(
          props,
          'params.backgroundColor',
          theme.mixins.Grey(100)
        ),
    },

    mainContent: {
      padding: 0,
      position: 'relative',
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'row',
      paddingTop: pxToRem(48),
      paddingBottom: pxToRem(48),
      [theme.breakpoints.up('lg')]: {
        paddingTop: pxToRem(84),
        paddingBottom: pxToRem(88),
        height: '100%',
      },
      // Remove borders
      '& .radio-btn-icon, & .MuiInput-formControl, & .rangeCalendarPicker': {
        border: 'none !important',
      },
      '& .MuiTypography-h2': {
        ...theme.mixins.marginLeft(0),
      },
      '& .MuiFormGroup-root': {
        '&[role=radiogroup]': {
          '& .radio-btn-Chekedicon': {
            border: theme.borders.seaGreenBorder,
            '&:before': {
              backgroundColor: theme.palette.common.SeaGreen,
              border: theme.borders.seaGreenBorder,
              content: '""',
            },
          },
        },
      },
    },
    heading: {
      width: pxToRem(304),
      [theme.breakpoints.up('lg')]: {
        width: pxToRem(640),
      },
      '& h2': {
        ...theme.palette.common.ellipsis(3),
      },
    },
    tabsContainer: {
      '& .MuiTabs-flexContainer': {
        [theme.breakpoints.up('lg')]: {
          width: pxToRem(175),
        },
      },
    },
    tabRoot: {
      '& .MuiTabs-root': {
        marginBottom: theme.spacing(1.5),
        marginTop: theme.spacing(4),
        '& .Mui-selected': {
          '& .MuiTypography-root': {
            opacity: 1,
          },
        },
        '& .MuiTypography-root': {
          color: props =>
            get(
              props,
              'params.textColor'
            ),
          opacity: 0.4,
        },
      },
    },
    contentSection: {
      width: '100%',
      color: props =>
        get(
          props,
          'params.textColor'
        ),
      [theme.breakpoints.up('lg')]: {
        flexBasis: '53%',
      },
    },
    imageSection: {
      display: 'none',

      [theme.breakpoints.up('lg')]: {
        position: 'relative',
        flexGrow: 0,
        flexBasis: '40%',
        display: 'block',

        '& img': {
          objectPosition: 'left',
        },

        '& .image-above': {
          position: 'absolute',
          top: '15%',
          width: '70%',
          height: '70%',
          zIndex: 1,
          ...left('-20%'),
          // Picture component add paddingTop: 125% with respect of image aspect ratio
          // especifically for this component we dont need it to achieve design
          paddingTop: 0,
        },
        '& .image-below': {
          height: '100%',
          width: '100%',

          '& .img-to-animate': {
            overflow: 'hidden',
            maxHeight: '720px',
          },
        },
      },
      [theme.breakpoints.up('xl')]: {
        flexBasis: '40.9%',

        '& .image-above': {
          top: '10%',
          width: '70%',
          height: '70%',
        },
        '& .image-below': {
          height: '100%',
          width: '100%',
          '& .img-to-animate': {
            overflow: 'hidden',
            maxHeight: '864px',
          },
        },
      },
    },
    formWrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      '& label': {
        fontFamily: theme.custom.fontFamily.primaryRegular,
        '&.MuiInputLabel-shrink': {
          fontFamily: theme.custom.fontFamily.primaryRegular,
        },
        '& span': {
          fontFamily: theme.custom.fontFamily.primaryRegular,
        },
        '&.Mui-focused': {
          color: 'inherit',
        },
      },
      '& .rangeCalendarPicker': {
        color: theme.mixins.Black(),
        '& label': {
          color: props =>
            get(
              props,
              'params.textColor'
            ),
        },
        '&:hover': {
          background: theme.mixins.White(),
        },
        '& svg': {
          color: theme.mixins.Black(),
        },
      },
      '& fieldset': {
        width: '100%',

        [theme.breakpoints.up('lg')]: {
          width: '45%',
          ...marginLR(0, pxToRem(16)),
        },
        '& .MuiAutocomplete-popperDisablePortal': {
          top: pxToRem(94),
        },

        '& label': {
          ...theme.palette.common.ellipsis(1),
        },
      },
      '& .MuiFormControlLabel-root': {
        ...marginLR(`-${pxToRem(11)}`, pxToRem(16)),
      },
      [theme.breakpoints.up('lg')]: {
        width: 'auto',
      },

      '& .btn-txt': {
        ...theme.palette.common.ellipsis(1),
      },
    },
    fullWidth: {
      flex: '0 0 100%',
    },
    button: {
      marginTop: pxToRem(32),
    },
    toDropdown: {
      '& .MuiInputBase-root .MuiSelect-select:hover': {
        backgroundColor: 'transparent',
      },
      '& .Mui-disabled': {
        color: theme.mixins.Black(),
      },
      '& .MuiSelect-icon': {
        display: 'none',
      },
    },
  };
});

export default useStyles;
